import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { AccessLoadError, useAccess } from '@/features/AccessProvider';
import { FullScreenLoader } from '@/components/ui/Loader';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { ready, isAuthenticated, user } = useAuth();
  const access = useAccess();
  const location = useLocation();

  if (!ready) return <FullScreenLoader label="Authenticating" />;
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (!access.isReady) return <FullScreenLoader label="Loading access" />;
  if (access.isError && !user?.is_superuser) return <AccessLoadError />;
  if (!access.hasAnyViewableResource) {
    return <Navigate to="/forbidden" replace />;
  }
  return <>{children}</>;
}
